var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.copied)?_c('unicon',{attrs:{"name":"copy"},nativeOn:{"click":function($event){return _vm.share.apply(null, arguments)}}}):_c('unicon',{attrs:{"name":"check"},nativeOn:{"click":function($event){return _vm.share.apply(null, arguments)}}}),(_vm.displayText)?_c('span',{staticClass:"copied-text"},[_vm._v("Copied!")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }